import { variables } from 'cssInJs';

export default{
    cmsEditMode : {
        backgroundColor: variables.darkGrayColor,
        color: 'white',
        fontSize: '1.5rem',
        padding: '1rem'
    }
}